<template>
    <section class=" text-center max-w-xl mx-auto pt-12">
        <BackButton :to="{ name: 'love-letter-prepare' }" />
        <Title class="ml-5">LoveLetter</Title>
        <button v-if="isLeader" class="mb-3 bg-gradient-to-r from-blue-400 to-blue-500 text-white font-bold py-4 px-4 rounded"
            @click="StartNewRound">Nouveau round</button>
        <Spinner v-if="!loaded" />
        <div v-else class="relative flex flex-col gap-y-2">
            <div>
                <div class="px-4 rounded-t-lg bg-violet-800 flex divide-x-2 divide-violet-600">
                    <div v-for="player in players" :key="player.id" @click="selectedPlayerId = player.id" 
                        :class="{ 'opacity-50': selectedPlayerId != player.id }"
                        class="w-full py-2">
                        {{player.id}}
                        {{ player.isAlive ? '' : '(Mort)'}}
                    </div>
                </div>
                <div class="bg-gray-600 p-2 flex flex-wrap  rounded-b-lg">
                    <LoveLetterCard v-for="(card, index) in selectedPlayer.playedCards" :key="card + index" :role="card" size="small" class="m-1" />
                </div>
            </div>
            <div class="grow space-x-3 flex py-12">
                <LoveLetterCard class="transform transition-transform duration-300"
                    @click.native="selectedCard = (selectedCard == index) ? null : index"
                    :class="selectedCard == index ? '-translate-y-8' : 'translate-y-0'"
                    v-for="(card, index) in player.activeCards" :key="card + index" :role="card" />
            </div>
            <div class="bg-violet-800 grid grid-cols-2">
                <button @click="PlayCard" :class="{'opacity-50': selectedCard == null }" class="border p-4 w-full">Jouer</button>
                <button @click="DrawCard" class="border p-4 w-full">Piocher ({{game.deck.length}})</button>
                <button @click="PutCardUnderDeck" :class="{'opacity-50': selectedCard == null }" class="border p-4 w-full">Remettre en dessous de la pioche</button>
                <button @click="SwitchDeadStatus" class="border p-4 w-full">Mort</button>
            </div>
        </div>
    </section>
</template>
<script>
import { mapFields } from '@/models'
import { mapActions, mapGetters, mapState } from 'vuex'
import LoveLetterCard from '@/components/LoveLetterCard'
import Modal from '@/components/Modal'
export default {
    components: {
        Modal,
        LoveLetterCard
    },
    data: () => ({
        loaded: false
    }),
    computed: {
        ...mapFields('LoveLetter', ['selectedCard', 'selectedPlayerId']),
        ...mapState('LoveLetter', ['code', 'username', 'game', 'players']),
        ...mapGetters('LoveLetter', ['isLeader', 'player', 'selectedPlayer'])
    },
    methods: {
        ...mapActions('LoveLetter', ['bindGame', 'bindPlayers', 'StartNewRound', 'DrawCard', 'PlayCard', 'PutCardUnderDeck', 'SwitchDeadStatus'])
    },
    mounted: async function () {
        if (this.code == null) return this.$router.push({ name: 'love-letter-prepare' })
        await this.bindGame();
        if (!(this.game && this.game.status == 'started')) return this.$router.push({ name: 'love-letter-lobby' })
        await this.bindPlayers();
        this.selectedPlayerId = this.player.id;
        this.loaded = true
    }
}
</script>